export default __webpack_public_path__ + "bb344e1e4c97c2c4096f33bf1cff7c85.png";